import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Services from "@/components/landing/Services";
import TrustStrip from "@/components/landing/TrustStrip";
import Process from "@/components/landing/Process";
import Testimonials from "@/components/landing/Testimonials";
import QuoteFormSection from "@/components/landing/QuoteFormSection";
import FAQ from "@/components/landing/FAQ";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main className="bg-background text-foreground">
      <Header />
      <Hero />
      <TrustStrip />
      <Services />
      <Process />
      <Testimonials />
      <QuoteFormSection />
      <FAQ />
      <ContactSection />
      <Footer />
    </main>
  );
}
